//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FilesFieldTreeNode from './FilesFieldTreeNode.vue'

export default {
  components: {
    FilesFieldTreeNode
  },
  props: {
    treeNode: {
      type: Object,
      default: null
    },
    file: {
      type: Object,
      required: true
    },
    selectModeEdit: {
      type: Boolean,
      default: false
    },
    mobile: {
      type: Boolean,
      default: false
    },
    expandFolder: {
      type: Function,
      default: null
    },
    category: {
      type: Object,
      default: null
    },
    disableDraggable: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      dragImage: null
    }
  },
  computed: {
    isDraggable: function () {
      return !this.disableDraggable
    }
  },
  mounted: function () {
    this.addDragAndDrop()
  },
  beforeDestroy: function () {
    this.removeDragAndDrop()
  },
  methods: {
    /**
     * Manage Drag and Drop API listeners
     */
    addDragAndDrop: function () {
      if (this.isDraggable) {
        this.addElementDragListeners()
        this.addTreeDragListeners()
      }
    },
    removeDragAndDrop: function () {
      if (this.isDraggable) {
        this.removeElementDragListeners()
        this.removeTreeDragListeners()
      }
    },
    addElementDragListeners: function () {
      const dragElement = this.$el.getElementsByClassName('files-field-tree-node__file-icon')[0]
      dragElement.setAttribute('draggable', 'true')
      dragElement.addEventListener('dragstart', this.onDragStart)
      dragElement.addEventListener('drag', this.onDrag)
      dragElement.addEventListener('dragend', this.onDragEnd)
      dragElement.style.cursor = 'move'
      this.$el.addEventListener('dragenter', this.onDragEnter)
    },
    removeElementDragListeners: function () {
      const dragElement = this.$el.getElementsByClassName('files-field-tree-node__file-icon')[0]
      dragElement.removeAttribute('draggable', 'true')
      dragElement.removeEventListener('dragstart', this.onDragStart)
      dragElement.removeEventListener('drag', this.onDrag)
      dragElement.removeEventListener('dragend', this.onDragEnd)
      this.$el.removeEventListener('dragenter', this.onDragEnter)
    },
    addTreeDragListeners: function () {
      const treeRef = this.getTreeRef()
      treeRef.$el.addEventListener('drop', this.onDrop)
      treeRef.$el.addEventListener('dragover', this.onDragOver)
      treeRef.$el.addEventListener('dragenter', this.onDragEnter)
    },
    removeTreeDragListeners: function () {
      const treeRef = this.getTreeRef()
      treeRef.$el.removeEventListener('drop', this.onDrop)
      treeRef.$el.removeEventListener('dragover', this.onDragOver)
      treeRef.$el.removeEventListener('dragenter', this.onDragEnter)
    },

    /**
     * Define Drag and Drop API listeners
     */
    onDragStart: function (e) {
      e.stopPropagation()

      const draggedFiles = []
      if (this.category.selectedFiles.length > 1 && this.category.selectedFiles.find(el => el._node.nodeKey == this.file._node.nodeKey)) {
        this.category.selectedFiles.forEach(el => {
          draggedFiles.push(el._node.nodeKey)
        })
      } else {
        draggedFiles.push(this.file._node.nodeKey)
      }

      e.dataTransfer.setData('draggedFiles', draggedFiles)

      const img = document.createElement('img')
      img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
      e.dataTransfer.setDragImage(img, 0, 0)

      this.dragImage = this.createDragImageElements(draggedFiles)
      document.getElementsByTagName('body')[0].appendChild(this.dragImage)

      this.dragImage.style.left = (e.clientX - 20) + 'px'
      this.dragImage.style.top = (e.clientY - this.dragImage.offsetHeight) + 'px'

      e.dataTransfer.dropEffect = 'move'
      e.dataTransfer.effectAllowed = 'move'
    },
    onDrag: function (e) {
      e.preventDefault()
      this.dragImage.style.left = (e.clientX - 20) + 'px'
      this.dragImage.style.top = (e.clientY - this.dragImage.offsetHeight) + 'px'
    },
    onDragOver: function (e) {
      e.preventDefault()
    },
    onDragEnter: function (e) {
      e.preventDefault()
      e.stopPropagation()

      if (this.file.type == 'folder') {
        this.expandFolder(this.file)
      }

      const parentEl = this.getParentFolderElement(e.target)
      this.setDraggedStyle(parentEl)
      this.setAllDefaultStyle(parentEl)
    },
    onDragLeave: function (e) {
      e.stopPropagation()

      const parentEl = this.getParentFolderElement(e.target)
      const parentElCoords = parentEl.getBoundingClientRect()
      if ((e.clientX > Math.max(parentElCoords.left, parentElCoords.right) || e.clientX < Math.min(parentElCoords.left, parentElCoords.right)) || (e.clientY > Math.max(parentElCoords.top, parentElCoords.bottom) || e.clientY < Math.min(parentElCoords.top, parentElCoords.bottom))) {
        this.setDefaultStyle(parentEl)
      }
    },
    onDrop: function (e) {
      e.preventDefault()
      e.stopPropagation()
      e.stopImmediatePropagation()

      this.setDefaultStyle(this.getParentFolderElement(e.target))

      if (document.getElementById('dragImage')) {
        document.getElementById('dragImage').remove()
      }

      let targetFolderId = -1
      const fileNodeElement = e.target.closest('.files-field-tree-node') || e.target
      if (fileNodeElement.__vue__ && fileNodeElement.__vue__._props.file && fileNodeElement.__vue__._props.file.type === 'folder') {
        const fileWrapperFolder = fileNodeElement.__vue__._props.file
        targetFolderId = fileWrapperFolder.id
      } else {
        const folderElement = e.composedPath().find(el => el.classList && el.classList.contains('q-tree__node--parent'))
        if (folderElement) {
          const fileWrapperFolder = folderElement.getElementsByClassName('files-field-tree-node')[0].__vue__._props.file
          targetFolderId = fileWrapperFolder.id
        }
      }

      if (e.dataTransfer.files.length !== 0) {
        e.targetFolder = targetFolderId
        this.$emit('upload-files', e)
      } else {
        const keys = e.dataTransfer.getData('draggedFiles')
        const keysArray = keys.split(',')
        keysArray.forEach(key => {
          const fileNode = this.findFileNode(this.category.filesTree, key)
          const targetFolder = this.category.getFolder(targetFolderId)
          if (!this.category.moveFileToFolder(fileNode._file, targetFolder)) {
            this.$q.notify({
              type: 'warning',
              message: 'Такое перемещение невозможно',
              progress: true,
              timeout: 8000
            })
          }
        })
      }
    },
    onDragEnd: function (e) {
      e.preventDefault()
      e.stopPropagation()
      if (e.dataTransfer.dropEffect === 'none') {
        this.setDefaultStyle(this.getParentFolderElement(e.target))
      }

      if (document.getElementById('dragImage')) {
        document.getElementById('dragImage').remove()
      }
    },

    /**
     * Additional methods
     */
    createDragImageElements: function (nodeKeys) {
      const div = document.createElement('div')
      const treeRef = this.getTreeRef()
      const nodes = treeRef.$el.getElementsByClassName('files-field-tree-node')
      nodeKeys.forEach(nodeKey => {
        let node = null
        for (let i = 0; i < nodes.length; i++) {
          if (nodes[i].__vue__.$vnode.data.key == nodeKey) {
            node = nodes[i].closest('.q-tree__node-header-content').cloneNode(true)
            node.style.width = nodes[i].offsetWidth + 'px'
            node.style.backgroundColor = 'white'
            node.style.borderStyle = 'dashed'
            node.style.borderWidth = '1px'
            node.style.borderRadius = '3px'
            node.style.borderColor = 'lightgray'
            break
          }
        }
        div.appendChild(node)
      })

      div.setAttribute('id', 'dragImage')
      div.style.position = 'absolute'
      div.style.height = 'fit-content'
      div.style.zIndex = '10000'
      return div
    },
    getTreeRef: function () {
      let parentEl = this.$parent
      while (parentEl.$parent) {
        if (parentEl.$refs && parentEl.$refs.tree) {
          return parentEl.$refs.tree
        }
        parentEl = parentEl.$parent
      }
      return null
    },
    getParentFolderElement: function (targetElement) {
      let parentEl = null
      const closestNodeEl = targetElement.closest('.q-tree__node--child')
      if (closestNodeEl && closestNodeEl.getElementsByClassName('files-field-tree-node')[0].__vue__._props.file.folder) {
        parentEl = closestNodeEl
      }
      if (!parentEl) {
        parentEl = targetElement.closest('.q-tree__node--parent')
        if (!parentEl || (parentEl && !parentEl.parentNode.closest('.q-tree__node--parent') && parentEl.isEqualNode(this.$el))) {
          parentEl = this.getTreeRef().$el
        }
      }
      return parentEl
    },
    setDraggedStyle: function (targetElement) {
      targetElement.style = 'background-color: #f2f2f2'
    },
    setDefaultStyle: function (targetElement) {
      targetElement.style = ''
    },
    setAllDefaultStyle: function (ignoredElement = null) {
      const treeRootElement = this.getTreeRef().$el
      if (!ignoredElement || (ignoredElement && !treeRootElement.isEqualNode(ignoredElement))) {
        treeRootElement.style = ''
      }
      const fileElements = treeRootElement.getElementsByClassName('q-tree__node--child')
      for (let i = 0; i < fileElements.length; i++) {
        if (!ignoredElement || (ignoredElement && !fileElements[i].isEqualNode(ignoredElement))) {
          fileElements[i].style = ''
        }
      }
      const folderElements = treeRootElement.getElementsByClassName('q-tree__node--parent')
      for (let i = 0; i < folderElements.length; i++) {
        // console.log(ignoredElement, folderElements[i])
        if (!ignoredElement || (ignoredElement && !folderElements[i].isEqualNode(ignoredElement))) {
          folderElements[i].style = ''
        }
      }
    },
    findFileNode: function (array, nodeKey) {
      if (typeof nodeKey === 'string') {
        const id = Number(nodeKey)
        if (!isNaN(id)) {
          nodeKey = id
        }
      }

      let result = array.find(el => el.nodeKey == nodeKey)
      if (!result) {
        for (let i = 0; i < array.length; i++) {
          if (!result && array[i].children) {
            result = this.findFileNode(array[i].children, nodeKey)
          }
        }
      }
      return result
    }
  }
}
